<template>
  <c-modal
    :id="$getConst('AGREEMENTS_EXISTS_MODAL_ID')"
    :padding="0"
    fluid
    overflow="hidden"
    variant="danger"
  >
    <div
      class="row"
      style="display: flex"
    >
      <div class="col-xs-6 modal-col-left">
        <div class="bg-image" />
        <div class="warning-image" />
      </div>
      <div class="col-xs-6 modal-col-right">
        <p>Внимание!</p>
        <p>У Вас имеются <span style="font-size: 2em; text-decoration: underline;">{{ clientAgreementsTotal }}</span> задачи с необходимыми работами по продвижению сайта.</p>
        <div>Для того, чтобы максимизировать эффект от поискового продвижения Вашего сайта, следует оперативно согласовать или предоставить информацию!</div>
      </div>
    </div>
  </c-modal>
</template>

<script>
import CModal from '../../../../../../../resources/js/components/ui/CModal'
import { mapState } from 'vuex'

export default {
  name: 'AgreementsExists',
  components: {
    CModal
  },
  computed: {
    ...mapState({
      clientAgreementsTotal: state => state.seo.client.agreements.total
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.bg-image {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-image: url('../../../../../../../resources/img/positions/depositphotos.jpg');
  background-position: center;
  background-size: cover;
}

.modal-col-left {
  padding: 0;
}

.modal-col-right {
  color: white;
  padding: 50px 15px;
}

.modal-col-right p {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
